module.exports = __webpack_public_path__ + "static/img/surfandscan_titel.effc188.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surfandscan_titel.jpg
// module id = 0hb7
// module chunks = 2